export default __webpack_public_path__ + "images/57171643f51703b9ba2b3ca0e81edb4a.svg";